import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { setAuthorization } from "../../src/api/api_helper";
 
import { useProfile } from "../hooks/UserHooks";

import { AUTH_PATHS } from "./paths";
import { useDispatch } from "react-redux";

const AuthProtected:React.FC<React.PropsWithChildren>  = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const { userProfile, loading, token } = useProfile();
  
  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && loading && !token) {
      navigate(AUTH_PATHS.LOGIN, { replace: true });

    }
  }, [token, userProfile, loading, dispatch]);

  /*
    Navigate is un-auth access protected routes via url
    */

  if (!userProfile && loading && !token) {
    return (
      <Navigate to={AUTH_PATHS.LOGIN} state={{ from: location }} replace />
    );
  }

  return <>{children}</>;
};

export { AuthProtected };